import type { LearnPracticalContent } from "../practicalContent.js";

export const floodStormContent: LearnPracticalContent = {
  th: {
    notice: [
      "ฝนหนัก น้ำเพิ่มเร็ว และคำเตือนในพื้นที่อาจหมายถึงน้ำท่วมหรือน้ำป่าใกล้เข้ามา",
      "น้ำท่วมอาจปนเปื้อนและซ่อนหลุม ของมีคม หรือกระแสไฟฟ้า",
      "พื้นที่ต่ำ ทางลอด ร่องระบายน้ำ และริมลำน้ำอาจมีน้ำเพิ่มเร็ว โดยเฉพาะตอนกลางคืน",
      "ไฟฟ้าดับ สัญญาณโทรศัพท์ไม่เสถียร และเส้นทางเปลี่ยนกะทันหันอาจเกิดร่วมกับพายุ จึงควรวางแผนสื่อสารและเดินทางไว้ก่อน",
    ],
    prepare: [
      "ติดตามพยากรณ์และประกาศท้องถิ่น เตรียมเส้นทางออกและกระเป๋าจำเป็น",
      "เก็บเอกสาร ยา และอุปกรณ์ไฟฟ้าที่เคลื่อนย้ายได้ให้สูงขึ้นเมื่อยังปลอดภัย",
      "รู้จุดสูงใกล้บ้านและเตรียมวิธีช่วยเด็ก ผู้สูงอายุ ผู้พิการ และสัตว์เลี้ยง",
      "ชาร์จอุปกรณ์สื่อสาร เตรียมน้ำดื่ม แบตเตอรี่หรือไฟฉาย และบันทึกช่องทางประกาศของอาคารหรือชุมชน",
    ],
    during: [
      "ทำตามคำสั่งอพยพ และไปยังพื้นที่สูงเมื่อหน่วยงานแจ้ง",
      "หลีกเลี่ยงน้ำท่วมและถนนที่มองไม่เห็นพื้น",
      "ถนนถูกกั้นหรือมีน้ำข้ามทาง ให้กลับรถและใช้เส้นทางอื่น ไม่ขับอ้อมสิ่งกีดขวาง",
      "ถ้าอยู่ในอาคาร ให้ติดตามคำสั่งผู้ดูแลอาคารและใช้บันไดเมื่อจำเป็น โดยไม่ใช้ลิฟต์หากมีน้ำหรือไฟฟ้าขัดข้อง",
    ],
    avoid: [
      "อย่าเดิน ขับรถ หรือว่ายผ่านน้ำที่ไม่รู้ความลึกหรือความแรง",
      "อย่าสัมผัสอุปกรณ์ไฟฟ้าขณะตัวเปียกหรือยืนอยู่ในน้ำ",
      "อย่าให้เด็กเล่นใกล้คูระบายน้ำ ท่อ หรือกระแสน้ำ และอย่ากลับบ้านก่อนพื้นที่ปลอดภัย",
      "อย่าเชื่อแผนที่น้ำท่วมหรือโพสต์ที่ไม่ระบุเวลาและพื้นที่โดยไม่เทียบกับประกาศทางการในพื้นที่",
    ],
    help: [
      "ขอความช่วยเหลือเมื่อถูกตัดขาด น้ำเพิ่มเร็ว มีผู้บาดเจ็บ หรือมีความเสี่ยงจากไฟฟ้า",
      "ใช้ประกาศของจังหวัด เทศบาล หรือหน่วยงานภัยพิบัติเป็นหลัก",
      "หากอยู่ในรถแล้วน้ำเพิ่มรอบตัว ให้ติดต่อเจ้าหน้าที่และทำตามคำแนะนำของผู้รับแจ้งเหตุ ไม่คาดเดาเส้นทางหนีเอง",
      "หากต้องใช้ยา อุปกรณ์แพทย์ หรือการเคลื่อนย้ายเป็นพิเศษ ให้แจ้งความต้องการนี้เมื่อขอความช่วยเหลือ",
    ],
    example:
      "ฝนหนักต่อเนื่องและน้ำเริ่มท่วมถนนหน้าอาคาร: ตรวจประกาศพื้นที่ เตรียมของจำเป็นและทางออก หลีกเลี่ยงการลองเดินหรือขับรถผ่านน้ำที่มองไม่เห็นพื้น",
    situations: [
      {
        title: "คอนโด",
        text: "ชาร์จโทรศัพท์ เตรียมยา เอกสาร และไฟฉาย แล้วติดตามประกาศนิติบุคคล ไม่ใช้ลิฟต์หากมีน้ำหรือระบบไฟฟ้าผิดปกติ",
      },
      {
        title: "ขับรถกลับบ้าน",
        text: "เมื่อเห็นน้ำปิดถนนหรือแผงกั้น ให้กลับรถและเลือกเส้นทางอื่น ไม่ลองวัดระดับน้ำด้วยรถของตนเอง",
      },
      {
        title: "ดูแลคนในบ้าน",
        text: "เตรียมแผนสำหรับคนใช้ยา เด็ก ผู้สูงอายุ และสัตว์เลี้ยงก่อนน้ำสูงขึ้น แล้วแจ้งความต้องการพิเศษเมื่อขอความช่วยเหลือ",
      },
    ],
    checklist: [
      "ติดตามคำเตือนพื้นที่",
      "รู้จุดสูงและเส้นทางสำรอง",
      "เตรียมยา เอกสาร และของจำเป็น",
      "ไม่ลงน้ำหรือขับฝ่าน้ำท่วม",
      "รอประกาศก่อนกลับพื้นที่",
      "ชาร์จโทรศัพท์และมีไฟฉาย",
      "วางแผนคนที่ต้องการความช่วยเหลือพิเศษ",
    ],
  },
  en: {
    notice: [
      "Heavy rain, rapidly rising water, and local warnings may signal an approaching flood or flash flood.",
      "Floodwater may be contaminated and hide holes, sharp objects, or electrical hazards.",
      "Low areas, underpasses, drains, and stream banks can fill rapidly, especially when hazards are harder to see at night.",
      "Power cuts, poor phone service, and rapidly changing routes can accompany a storm, so plan communication and travel ahead.",
    ],
    prepare: [
      "Monitor forecasts and local alerts; prepare an exit route and essential bag.",
      "Move documents, medicines, and portable electrical items higher while it is still safe.",
      "Know nearby higher ground and plan assistance for children, older people, disabled people, and pets.",
      "Charge communication devices, keep drinking water, batteries or a torch, and save the building or community alert channels.",
    ],
    during: [
      "Follow evacuation orders and move to higher ground when directed.",
      "Keep out of floodwater and roads where the surface cannot be seen.",
      "Turn around when a road is closed or covered by water; use another route and never drive around a barrier.",
      "Inside a building, follow building-management instructions and use stairs when necessary; do not use a lift where water or an electrical fault is involved.",
    ],
    avoid: [
      "Do not walk, drive, or swim through water of unknown depth or force.",
      "Do not touch electrical equipment while wet or standing in water.",
      "Keep children away from drains and moving water, and do not return before the area is declared safe.",
      "Do not rely on a flood map or post without a time and location without checking the current local authority notice.",
    ],
    help: [
      "Seek help if you are cut off, water is rising quickly, someone is injured, or electricity is a concern.",
      "Use province, municipality, and disaster-authority instructions for your location.",
      "If water is rising around a vehicle, contact responders and follow the call-taker's directions rather than guessing an escape route.",
      "State any need for regular medicines, powered medical equipment, or assisted movement when requesting help.",
    ],
    example:
      "Rain continues and water covers the road outside: check local alerts, ready your essentials and route out, and do not test water when the road surface is hidden.",
    situations: [
      {
        title: "Apartment",
        text: "Charge a phone, ready medicines, documents, and a torch, then follow building-management notices. Do not use a lift if water or electrical systems are affected.",
      },
      {
        title: "Driving home",
        text: "When water closes a road or a barrier is in place, turn around and choose another route. Do not use your vehicle to test the depth.",
      },
      {
        title: "Caring for household members",
        text: "Plan early for medicine users, children, older adults, and pets, and state special needs when requesting assistance.",
      },
    ],
    checklist: [
      "Monitor local warnings",
      "Know higher ground and a backup route",
      "Prepare medicines, documents, and essentials",
      "Stay out of floodwater",
      "Wait for official advice before returning",
      "Keep a charged phone and torch",
      "Plan for people needing extra assistance",
    ],
  },
};
